import { Injectable } from '@angular/core';
import * as d3 from 'd3';


@Injectable()
export class WidegtHelperService {
  
  private LOCALE_MAPPING: any[] = [
        { locale: "en-US", FormatJSON: { "NumericLocale": {"decimal": ".", "thousands": ",", "grouping": [3], "currency": ["", "\u00a0$"]}, "ChartLocale" : { "dateTime": "%d-%b-%y", "date": "%d-%b-%y", "time": "%H:%M:%S", "periods": ["AM", "PM"], "days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], "shortDays": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], "months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], "shortMonths": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}}},
        { locale: "de-DE", FormatJSON: { "NumericLocale": {"decimal": ",", "thousands": ".", "grouping": [3], "currency": ["", "\u00a0€"]}, "ChartLocale" : { "dateTime": "%d-%b-%y", "date": "%d-%b-%y", "time": "%H:%M:%S", "periods": ["AM", "PM"], "days": ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"], "shortDays": ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"], "months": ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"], "shortMonths": ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"]}}},
        { locale: "en-GB", FormatJSON: { "NumericLocale": {"decimal": ".","thousands": ",","grouping": [3],"currency": ["£", ""]}, "ChartLocale" : {"dateTime": "%a %e %b %X %Y","date": "%d/%m/%Y","time": "%H:%M:%S","periods": ["AM", "PM"],"days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],"shortDays": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],"months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],"shortMonths": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]}}},
        { locale: "es-ES", FormatJSON: { "NumericLocale": {"decimal": ",","thousands": ".","grouping": [3],"currency": ["", "\u00a0€"]}, "ChartLocale" : {"dateTime": "%A, %e de %B de %Y, %X","date": "%d/%m/%Y","time": "%H:%M:%S","periods": ["AM", "PM"],"days": ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],"shortDays": ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],"months": ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],"shortMonths": ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]}}},
        { locale: "fr-FR", FormatJSON: { "NumericLocale": {"decimal": ",","thousands": " ","grouping": [3],"currency": ["", "\u00a0€"],"percent": "\u202f%"}, "ChartLocale" : {"dateTime": "%A, le %e %B %Y, %X","date": "%d/%m/%Y","time": "%H:%M:%S","periods": ["AM", "PM"],"days": ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],"shortDays": ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],"months": ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],"shortMonths": ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."]}}},
        { locale: "it-IT", FormatJSON: { "NumericLocale": {"decimal": ",","thousands": ".","grouping": [3],"currency": ["€", ""]}, "ChartLocale" : {"dateTime": "%A %e %B %Y, %X","date": "%d/%m/%Y","time": "%H:%M:%S","periods": ["AM", "PM"],"days": ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],"shortDays": ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],"months": ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],"shortMonths": ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"]}}},
        { locale: "pt-PT", FormatJSON: { "NumericLocale": {"decimal": ",","thousands": ".","grouping": [3],"currency": ["R$", ""]}, "ChartLocale" : {"dateTime": "%A, %e de %B de %Y. %X","date": "%d/%m/%Y","time": "%H:%M:%S","periods": ["AM", "PM"],"days": ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],"shortDays": ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],"months": ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],"shortMonths": ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"]}}},
        { locale: "tr-TR", FormatJSON: { "NumericLocale": {"decimal": ",","thousands": ".","grouping": [3],"currency": ["€", ""]}, "ChartLocale" : {"dateTime": "%a %e %b %X %Y","date": "%d/%m/%Y","time": "%H:%M:%S","periods": ["AM", "PM"],"days": ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"],"shortDays": ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],"months": ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],"shortMonths": ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"]}}},
        { locale: "zh-CN", FormatJSON: { "NumericLocale": {"decimal": ".","thousands": ",","grouping": [3],"currency": ["¥", ""]}, "ChartLocale" : {"dateTime": "%x %A %X","date": "%Y年%-m月%-d日","time": "%H:%M:%S","periods": ["上午", "下午"],"days": ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],"shortDays": ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],"months": ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],"shortMonths": ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]}}},
        { locale: "pl-PL", FormatJSON: { "NumericLocale": {"decimal": ",","thousands": ".","grouping": [3],"currency": ["", "zł"]}, "ChartLocale" : {"dateTime": "%A, %e %B %Y, %X","date": "%d/%m/%Y","time": "%H:%M:%S","periods": ["AM", "PM"],"days": ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"],"shortDays": ["Niedz.", "Pon.", "Wt.", "Śr.", "Czw.", "Pt.", "Sob."],"months": ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"],"shortMonths": ["Stycz.", "Luty", "Marz.", "Kwie.", "Maj", "Czerw.", "Lipc.", "Sierp.", "Wrz.", "Paźdz.", "Listop.", "Grudz."]}}}
     ]
        
     // gets the locale format for given language
     public getLocaleFormat(language :string) : JSON 
     {
          let culture = this.LOCALE_MAPPING.find(f => f.locale === language);
          if(culture == null || culture.FormatJSON == null)
          {
            let cultureUS = this.LOCALE_MAPPING.find(f => f.locale === "en-US");
            return cultureUS.FormatJSON;
          }          
          else{
            return culture.FormatJSON;
          }
      }

    getDivisionForLegend(legendPosition: string, legendStyle: any, legendData: any, section: any, widgetDimensions: any): number {
        var maxsize = 0;
        var maxSizeforvalue = 0;
        for (var i = 0; i < legendData.length; i++) {
            if (legendData[i].value != undefined && legendData[i].value != null && !(Math.floor(legendData[i].value) == legendData[i].value)) {
                legendData[i].value = legendData[i].value.toFixed(2);
            }
            var dummyText = section.append("text")
                .attr("x", 0)
                .attr("y", 0)
                .attr("fill", "transparent")
                .attr("text-anchor", "middle")
                .attr("font-size", legendStyle["font-size"] + "px")
                .style("font-size", legendStyle["font-size"] + "px")
                .attr("font-family", legendStyle["font-family"])
                .text(legendData[i].key)
                .attr("class", "temp");

            var textWidth = dummyText.node().getBBox().width;

            maxsize = maxsize > textWidth ? maxsize : textWidth;

            var dummyTextforValue = section.append("text")
                .attr("x", 0)
                .attr("y", 0)
                .attr("fill", "transparent")
                .attr("text-anchor", "middle")
                .attr("font-size", legendStyle["font-size"] + "px")
                .style("font-size", legendStyle["font-size"] + "px")
                .attr("font-family", legendStyle["font-family"])
                .text(() => {
                    var value = legendData[i].value == undefined || legendData[i].value == null ? " " : ": " + legendData[i].value
                    return value;
                })
                .attr("class", "temp");

            var textWidthforValue = dummyTextforValue.node().getBBox().width;

            maxSizeforvalue = maxSizeforvalue > textWidthforValue ? maxSizeforvalue : textWidthforValue;
        }
        section.selectAll(".temp").remove();

        if (legendPosition === "top" || legendPosition === "bottom") {
            var extraMargin = legendData[0].id != undefined ? 35 : 15;
            var sizeRequiredForEachItem = maxsize + 10 + maxSizeforvalue + 10 + extraMargin; //size of label + size of rect + size of number + extra margin 
            var itemsthatCanFitInOneRow = Math.floor(widgetDimensions["width"] / sizeRequiredForEachItem);
            itemsthatCanFitInOneRow = itemsthatCanFitInOneRow - 1 == 0 ? 1 : itemsthatCanFitInOneRow;

            var legendItems = section.append("g")
                .attr("class", "templegend")

            var xIndicator = 0

            var itemsinsertedinRow = 0;

            var rownumber = 0
            var translateY = rownumber * 15
            var recXPosition = 0;
            var textXPosition = extraMargin;
            var valueXPosition = maxsize + textXPosition;

            for (var i = 0; i < legendData.length; i++) {
                var legendItem = legendItems.append("g").attr("id", legendData[i].id != undefined ? legendData[i].id : 0)
                //.attr("hidden", false)

                legendItem.attr("transform", function () { return "translate(0," + translateY + ")"; });

                legendItem.append("rect")
                    .attr("x", recXPosition + (legendData[i].id != undefined ? 20 : 0))
                    .attr("width", 10)
                    .attr("height", 10)
                    .style("fill", legendData[i].color)

                legendItem.append("text")
                    .attr("width", maxsize)
                    .attr("x", textXPosition)
                    .attr("y", 4)
                    .attr("dy", ".35em")
                    .style("text-anchor", "start")
                    .style("font-size", legendStyle["font-size"] + "px")
                    .style("fill", legendStyle["fill"])
                    .style("font-family", legendStyle["font-family"])
                    .text(legendData[i].key);

                // reason x value is +10 {10 rect width + 5 extra margin for text }
                legendItem.append("text")
                    .attr("x", valueXPosition)
                    .attr("y", 4)
                    .attr("dy", ".35em")
                    .style("text-anchor", "start")
                    .style("font-size", legendStyle["font-size"] + "px")
                    .style("fill", legendStyle["fill"])
                    .style("font-family", legendStyle["font-family"])
                    .text(() => {
                        var value = legendData[i].value == undefined || legendData[i].value == null ? " " : ": " + legendData[i].value
                        return value;
                    })

                if (legendData[i].id != undefined) {
                        legendItem.append("image")
                        .attr("x", recXPosition)
                         .attr("y", 0)
                         .attr("width", 12)
                         .attr("height", 12)
                         .attr("class", "imageShowHide")
                        .attr("xlink:href", "assets/hideEye.png")
                }

                itemsinsertedinRow++;

                if (itemsinsertedinRow == itemsthatCanFitInOneRow) {
                    rownumber++;
                    translateY = rownumber * 15
                    recXPosition = 0;
                    textXPosition = extraMargin;
                    valueXPosition = maxsize + textXPosition;
                    itemsinsertedinRow = 0;
                }
                else {
                    recXPosition = valueXPosition + maxSizeforvalue + extraMargin;
                    textXPosition = recXPosition + extraMargin
                    valueXPosition = textXPosition + maxsize;
                }
            }

            rownumber++;
        }
        else {
            if (legendData && legendData.length > 0) {
                let offset = widgetDimensions["height"] / legendData.length;
                if (offset > 15) {
                    offset = 15;
                }

                var legendItems = section.append("g")
                    .attr("class", "templegend")

                for (var i = 0; i < legendData.length; i++) {
                    var legendItem = legendItems.append("g").attr("id", legendData[i].id != undefined ? legendData[i].id : 0)
                    //.attr("hidden", false)

                    legendItem.attr("transform", function () { return "translate(0," + i * offset + ")"; });

                    legendItem.append("rect")
                        .attr("x", 0)
                        .attr("width", 10)
                        .attr("height", 10)
                        .style("fill", legendData[i].color)

                    legendItem.append("text")
                        .attr("width", maxsize)
                        .attr("x", 15)
                        .attr("y", 4)
                        .attr("dy", ".35em")
                        .style("text-anchor", "start")
                        .style("font-size", legendStyle["font-size"] + "px")
                        .style("fill", legendStyle["fill"])
                        .style("font-family", legendStyle["font-family"])
                        .text(legendData[i].key);

                    // reason x value is +10 {10 rect width + 5 extra margin for text }
                    legendItem.append("text")
                        .attr("width", maxSizeforvalue)
                        .attr("x", maxsize + 15)
                        .attr("y", 4)
                        .attr("dy", ".35em")
                        .style("text-anchor", "start")
                        .style("font-size", legendStyle["font-size"] + "px")
                        .style("fill", legendStyle["fill"])
                        .style("font-family", legendStyle["font-family"])
                        .text(() => {
                            var value = legendData[i].value == undefined || legendData[i].value == null ? " " : ": " + legendData[i].value
                            return value;
                        })

                }
            }
            return 0;
        }

        return rownumber;
    }
    textWrap(inputElement) {
        var textNode = inputElement.node().parentNode,
            parentWidth = textNode.getAttribute("width") == null ? textNode.parentNode.clientWidth : textNode.getAttribute("width");

        inputElement.each(function (d) {
            var textElement = d3.select(this),
                allWords = this.textContent.split(' ').reverse(),
                word,
                lineArr = [],
                lineNumber = 0,
                lineHeight = 1.5,
                x = textElement.attr("x"),
                y = textElement.attr("y"),
                dy = 0,
                tspan = textElement.text(null)
                    .append("tspan")
                    .attr("x", x)
                    .attr("y", y)
                    .attr("dy", dy + "em");

            while (word = allWords.pop()) {
                lineArr.push(word);
                tspan.text(lineArr.join(" "));
                var node: SVGTSpanElement = <SVGTSpanElement>tspan.node();
                if (node.getComputedTextLength() > parentWidth) {
                    lineArr.pop();
                    tspan.text(lineArr.join(" "));
                    lineArr = [word];
                    tspan = textElement.append("tspan")
                        .attr("x", x != null ? x : 0)
                        .attr("y", y)
                        .attr("dy", lineHeight + dy + "em")
                        .text(word);
                }
            }
        });
    }


}
